<template>
  <a-modal
    :title="modalTit"
    :visible="isLimitDialogShow"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    class="set-option-dialog"
    width="400px"
    :confirm-loading="confirmLoading"
    :destroy-on-close="true"
    :mask-closable="false"
    @ok="formHandle"
    @cancel="cancelHandle"
  >
    <div
      class="input-form"
    >
      <a-tree
        checkable
        :expanded-keys="expandedKeys"
        :default-checked-keys="checkedData"
        :auto-expand-parent="autoExpandParent"
        :selected-keys="selectedKeys"
        :tree-data="options"
        @expand="onExpand"
        @select="onSelect"
        @check="onCheck"
      >
        <template
          slot="key"
          slot-scope="{title}"
        >
          <span>
            {{ title.title }}
          </span>
        </template>
      </a-tree>
    </div>
  </a-modal>
</template>
<script>
export default {
  components: {
  },
  props: {
    options: {
      type: Array,
      default () {
        return []
      }
    },
    data: {
      type: Array,
      default () {
        return []
      }
    },
    checkedData: {
      type: Array,
      default () {
        return []
      }
    },
    cloneData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false,
      expandedKeys: this.checkedData,
      autoExpandParent: true,
      checkedKeys: this.checkedData,
      selectedKeys: [],
      halfCheckedkeys: []
    }
  },
  computed: {
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    },
    modalTit () {
      return this.$t('message["1198"]')
    }
  },
  mounted () {
    this.checkedKeys = this.checkData
  },
  created () {
    this.form = this.$form.createForm(this)
    // this.form.getFieldDecorator('name', { initialValue: [], preserve: false })
  },
  methods: {
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    onExpand (expandedKeys) {
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onCheck (checkedKeys, e) {
      this.checkedKeys = checkedKeys
      this.halfCheckedkeys = e.halfCheckedKeys
    },
    onSelect (selectedKeys, info) {
      this.selectedKeys = selectedKeys
    },
    formHandle () {
      if (this.checkedKeys && this.checkedKeys.length) {
        let arr = [...this.checkedKeys, ...this.halfCheckedkeys]
        arr.forEach(item => {
          this.loopDatas(this.data, item)
        })
        this.checkedKeys = []
        this.halfCheckedkeys = []
        arr = []
        this.isLimitDialogShow = false
      }
    },
    cancelHandle () {
      this.isLimitDialogShow = false
      // this.options.forEach(item => {
      //   if (Object.keys(item).indexOf('isTemp') > -1) {
      //     delete this.item.isTemp
      //   }
      // })
      // this.$set(this.itemData, 'options', this.cloneData.options)
    },
    loopDatas (arr, key) {
      arr.forEach(item => {
        if (item.key === key) {
          // item.isshow = true
          this.$set(item, 'isshow', true)
        }
        if (item.children) {
          this.loopDatas(item.children, key)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .input-form::v-deep {
    margin:11px 20px 11px;
    .ant-checkbox-wrapper {
      margin-bottom: 0;
    }

  }
  </style>
